module.exports = __webpack_public_path__ + "img/sweden-ovarian-cancer-female.c13c2bee.png";